module.exports = __webpack_public_path__ + "media/components/assets/img/airplane-8fdd4f6860821afea3efbfededc3475a.png";